/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelOrderReasonAdminDto } from '../models/CancelOrderReasonAdminDto';
import type { CancelOrderReasonAdminListedDtoAdmin } from '../models/CancelOrderReasonAdminListedDtoAdmin';
import type { CancelOrderReasonsClientDtoResponseClient } from '../models/CancelOrderReasonsClientDtoResponseClient';
import type { GetCancelOrderReasonOperatorResponse } from '../models/GetCancelOrderReasonOperatorResponse';
import type { PostPutCancelOrderReasonRequestAdmin } from '../models/PostPutCancelOrderReasonRequestAdmin';
import type { RoleType } from '../models/RoleType';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CancelOrderReasonsService {
    /**
     * @returns GetCancelOrderReasonOperatorResponse OK
     * @throws ApiError
     */
    public static getCancelOrderReasonsOperator({
        role,
    }: {
        role?: RoleType,
    }): CancelablePromise<GetCancelOrderReasonOperatorResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/operator/v1/cancelorderreasons',
            query: {
                'role': role,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns CancelOrderReasonsClientDtoResponseClient OK
     * @throws ApiError
     */
    public static getCancelOrderReasonsClient({
        role,
    }: {
        role?: RoleType,
    }): CancelablePromise<CancelOrderReasonsClientDtoResponseClient> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/cancelorderreasons',
            query: {
                'role': role,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCancelOrderReasons`
     * @returns CancelOrderReasonAdminDto OK
     * @throws ApiError
     */
    public static getCancelOrderReasonByIdAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<CancelOrderReasonAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/cancelorderreasons/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCancelOrderReasons`
     * @returns CancelOrderReasonAdminDto OK
     * @throws ApiError
     */
    public static putCancelOrderReasonAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PostPutCancelOrderReasonRequestAdmin,
    }): CancelablePromise<CancelOrderReasonAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/cancelorderreasons/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteCancelOrderReasons`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteCancelOrderReasonAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/cancelorderreasons/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCancelOrderReasons`
     * @returns CancelOrderReasonAdminListedDtoAdmin OK
     * @throws ApiError
     */
    public static getCancelOrderReasonsAdmin({
        role,
    }: {
        role?: RoleType,
    }): CancelablePromise<Array<CancelOrderReasonAdminListedDtoAdmin>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/cancelorderreasons',
            query: {
                'role': role,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCancelOrderReasons`
     * @returns CancelOrderReasonAdminDto Created
     * @throws ApiError
     */
    public static postCancelOrderReasonAdmin({
        requestBody,
    }: {
        requestBody?: PostPutCancelOrderReasonRequestAdmin,
    }): CancelablePromise<CancelOrderReasonAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/cancelorderreasons',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
